import React from 'react';
import { Element, useEditor } from '@craftjs/core';
import { makeStyles } from '@material-ui/core/styles';
import { Box, IconButton, Typography } from '@material-ui/core';

import CropSquareIcon from '@material-ui/icons/CropSquare';
import TextFieldsIcon from '@material-ui/icons/TextFields';
import ImageIcon from '@material-ui/icons/Image';
import GestureIcon from '@material-ui/icons/Gesture';

import { Container } from '../../selectors/Container';
import { Text } from '../../selectors/Text';
import { Image } from '../../selectors/Image';
import { Signature } from '../../selectors/Signature';

const useStyles = makeStyles((theme) => ({
  root: {
    transition: 'width 0.4s cubic-bezier(0.19, 1, 0.22, 1)',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: (props) => (props.enabled ? '240px' : '0'),
    opacity: (props) => (props.enabled ? 1 : 0),
    overflow: 'hidden',
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  header: {
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  itemsContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    alignItems: 'center',
    paddingTop: theme.spacing(2),
    gap: theme.spacing(1),
  },
  item: {
    cursor: 'move',
    borderRadius: '10px',
    color: `${theme.palette.type === 'dark' ? '#eee' : 'rgba(0, 0, 0, 0.8)'} !important`,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    }
  },
}));

export const Toolbox = () => {
  const { enabled, connectors } = useEditor((state) => ({
    enabled: state.options.enabled,
  }));

  const classes = useStyles({ enabled });

  return (
    <Box className={classes.root}>
      <div className={classes.header}>
        <Typography variant="subtitle1">Bloques</Typography>
      </div>
      <div className={classes.itemsContainer}>
          <IconButton
            className={classes.item}
            ref={(ref) =>
              connectors.create(
                ref,
                <Element
                  canvas
                  is={Container}
                  height="100px"
                  width="100%"
                />
              )
            }
          >
            <CropSquareIcon /> Contenedor
          </IconButton>

          <IconButton
            className={classes.item}
            ref={(ref) =>
              connectors.create(ref, <Text fontSize="14" text="Nuevo Texto" />)
            }
          >
            <TextFieldsIcon /> Texto
          </IconButton>
          
          <IconButton
            className={classes.item}
            ref={(ref) => connectors.create(ref, <Image />)}
          >
            <ImageIcon /> Imagen
          </IconButton>
          
          <IconButton
            className={classes.item}
            ref={(ref) => connectors.create(ref, <Signature />)}
          >
            <GestureIcon /> Firma
          </IconButton>
      </div>
    </Box>
  );
};
